import { createCustomInstance } from '@stepstone-genesis/system';
const widgetStyleInstance = createCustomInstance({
    key: 'company-hub-premium',
});
export { widgetStyleInstance };
